import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { XMarkIcon, InformationCircleIcon, EyeIcon } from '@heroicons/react/24/solid';
import IconButton from '../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var showToast = function showToast(message, variant, config) {
  var icon;

  switch (variant) {
    case 'reversed':
      icon = /*#__PURE__*/_jsx(EyeIcon, {
        className: "h-6 w-6 fill-neutral-10"
      });
      break;

    case 'restworld':
      icon = '🎉';
      break;

    default:
      icon = /*#__PURE__*/_jsx(InformationCircleIcon, {
        className: "h-6 w-6"
      });
  }

  toast(function (_ref) {
    var closeToast = _ref.closeToast;
    return /*#__PURE__*/_jsx(CustomToast, {
      message: message,
      variant: variant,
      closeToast: closeToast,
      icon: icon
    });
  }, _objectSpread({}, config));
};
export var closeAllToasts = function closeAllToasts() {
  return toast.dismiss();
};

var CustomToast = function CustomToast(_ref2) {
  var message = _ref2.message,
      closeToast = _ref2.closeToast,
      variant = _ref2.variant,
      icon = _ref2.icon;
  return /*#__PURE__*/_jsx(ToastContentWrapper, {
    children: /*#__PURE__*/_jsxs(ToastContent, {
      variant: variant,
      children: [/*#__PURE__*/_jsxs(IconAndMessageWrapper, {
        children: [icon && /*#__PURE__*/_jsx("span", {
          children: icon
        }), /*#__PURE__*/_jsx("span", {
          children: message
        })]
      }), /*#__PURE__*/_jsx(IconButtonWrapper, {
        children: /*#__PURE__*/_jsx(IconButton, {
          ariaLabel: "close",
          Icon: XMarkIcon,
          onClick: closeToast,
          variant: variant === 'restworld' ? 'reversed' : variant
        })
      })]
    })
  });
};

var ToastContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toast-v2__ToastContentWrapper",
  componentId: "sc-sb50p8-0"
})(["", ""], {
  "backgroundColor": "transparent",
  "padding": "1rem",
  "@media (min-width: 768px)": {
    "padding": "0px"
  }
});

var ToastContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toast-v2__ToastContent",
  componentId: "sc-sb50p8-1"
})(function (_ref3) {
  var variant = _ref3.variant;
  return [{
    "display": "flex",
    "width": "auto",
    "maxWidth": "525px",
    "alignItems": "center",
    "justifyContent": "space-between",
    "gap": "0.5rem",
    "borderRadius": "0.5rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.5)",
    "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
    "@media (min-width: 1024px)": {
      "gap": "1rem",
      "paddingLeft": "1.5rem",
      "paddingRight": "1.5rem",
      "paddingTop": "1rem",
      "paddingBottom": "1rem"
    }
  }, variant === 'restworld' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(250 250 250 / var(--tw-text-opacity))"
  } : variant === 'reversed' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(28 28 51 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(250 250 250 / var(--tw-text-opacity))"
  } : variant === 'success' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(230 241 236 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 84 45 / var(--tw-text-opacity))"
  } : variant === 'error' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))"
  } : {}];
});

var IconAndMessageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toast-v2__IconAndMessageWrapper",
  componentId: "sc-sb50p8-2"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "fontSize": "14px",
  "fontWeight": "500",
  "@media (min-width: 1024px)": {
    "gap": "1rem",
    "fontSize": "16px"
  }
});

var IconButtonWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toast-v2__IconButtonWrapper",
  componentId: "sc-sb50p8-3"
})(["", ""], {
  "minWidth": "40px"
});